import { SET_PROVIDER } from './constants';

const setProvider = (provider) => {
  return {type: SET_PROVIDER, payload: provider};
};

export const providerActions = {
  setProvider,
};
